<template>
  <div class="orderlist bj freight-container">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:left>
        <el-button @click="binding" type="primary">绑定销售</el-button>
      </template>
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          :disabled="!tableData.length || disabledExport"
          type="warning"
          icon="el-icon-download"
          >导出</el-button
        >
      </template>
    </Filtersearch>
    <!-- <div class="title">
      <div class="d-flex a-center">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          class="bjsearch"
          @click="Refresh"
        ></el-button>
        <el-button @click="binding" type="primary">绑定销售</el-button>
      </div>
      <div class="seach">
        <div class="inputs">
          <el-select
            v-model="from1.sale_id"
            clearable
            filterable
            placeholder="所属销售"
          >
            <el-option
              :label="item.fullname"
              :value="item.id"
              :key="item.id"
              v-for="item in salelist"
            ></el-option>
          </el-select>
        </div>
        <div class="inputs">
          <el-input
            v-model="from1.mobile"
            placeholder="请输入联系电话"
            clearable
          ></el-input>
        </div>
        <el-button @click="search" type="primary" icon="el-icon-search"
          >查询</el-button
        >
      </div>
    </div> -->

    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="80" fixed align="center">
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="客户名称">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.fullname) }}
          </template>
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="客户备注">
          <template slot-scope="scope">
            <div @click="onEditRemark(scope.row)">
              {{ scope.row.take_order_remark }}
              <i
                class="el-icon-edit"
                style="color: #13ae67 !important; font-size: 16px"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="order_no" align="center" label="默认自提点">
          <template slot-scope="scope">
            {{
              $empty.empty(
                scope.row.member_default_delivery[0]?.store_delivery?.name
              )
            }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="客户电话">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.mobile) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="店铺名称">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.shopname) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="从事行业">
          <template slot-scope="scope">
            {{ $empty.empty(industry[scope.row.industry]) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="注册时间">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="注册天数">
          <template slot-scope="scope">
            {{ scope.row.days }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="日均下单件数">
          <template slot-scope="scope">
            {{ scope.row.average_order_number }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="下单总件数">
          <template slot-scope="scope">
            {{ scope.row.order_qty }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="name" align="center" label="日均下单重量">
          <template slot-scope="scope">
            {{ scope.row.average_order_gross_weight }}
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="下单总重">
          <template slot-scope="scope">
            {{ scope.row.order_gross_weight }}
          </template>
        </el-table-column> -->
        <el-table-column prop="name" align="center" label="复购率(%)">
          <template slot-scope="scope">
            {{ scope.row.rep_rate }}
          </template>
        </el-table-column>
        <el-table-column prop="sale_fullname" align="center" label="所属销售">
          <template slot-scope="scope">
            {{ scope.row.sale_fullname }}
          </template>
        </el-table-column>
        <el-table-column
          prop="labels"
          align="center"
          label="标签"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ labelstitle(scope.row.labels) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="star_customer_grade_detail"
          align="center"
          label="客户等级"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          prop="purchase_hierarchy"
          align="center"
          label="客户购买能力"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="customer_activity_txt"
          align="center"
          label="客户活跃度"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="customer_status_txt"
          align="center"
          label="客户下单状态"
          min-width="100"
        >
        </el-table-column>

        <el-table-column
          prop="black_status"
          align="center"
          label="客户状态"
          min-width="100"
        >
          <template slot-scope="scope">
            {{
              blackStatusList.find(
                (item) => item.value === scope.row.black_status
              ).label
            }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click="CustomerDetailschange(scope.row)"
              type="text"
              size="small"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <bindingsales @getList="getList" ref="bindingsales"></bindingsales>
    <!-- 商品详情 start -->
    <CustomerDetailsDialog
      ref="CustomerDetailsDialogref"
    ></CustomerDetailsDialog>
    <!-- 商品详情 end -->

    <remarkDialog ref="remarkDialogRef" @dialogVisibleChange="getList" />
  </div>
</template>
<script>
import bindingsales from "./modules/bindingsales.vue";
import Filtersearch from "@/components/Filtersearch.vue";
import { posttdcMemberListExport } from "@/api/export/center";
import CustomerDetailsDialog from "./modules/CustomerDetailsDialog/index";
import {
  DISABLED_STATUS,
  MEMBER_VIP_STATUS,
  PROFESSION_MAP,
} from "./menber.js";
import remarkDialog from "./modules/remarkDialog.vue";
export default {
  name: "member",
  components: {
    bindingsales,
    Filtersearch,
    CustomerDetailsDialog,
    remarkDialog,
  },
  data() {
    return {
      blackStatusList: Object.values(DISABLED_STATUS), // 状态枚举
      disabledExport: false,
      //列表新建页面初始参数
      loading: true,
      liquidate_amount_total: "",
      industry: {
        1: "中大型商超",
        2: "水果生鲜店",
        3: "企事业单位业务",
        4: "二批商户",
        5: "团购/团购领域",
        99: "—",
      },
      from: {
        sale_id: "",
        mobile: "",
        fullname: "", //会员名称
        min_register_date: "", //最小注册时间
        max_register_date: "", //最大注册时间
        min_register_day: "", //最小注册天数
        max_register_day: "", //最大注册天数
        industry: "", //行业id
        min_weight: "", //最小重量
        max_weight: "", //最大重量
        min_order_number: "", //最小订单数
        max_order_number: "", //最大订单数
        is_vip: "", //是否会员 0否 1是
        member_label_ids: [], //会员标签列表
        member_grade: "", // 用户等级 单选
        purchase_hierarchy: [], //购买能力 多选
        customer_activity: "", //客户活跃度 单选
        customer_status: [], //下单状态 多选
        lossing_customer_reason: "", //原因 单选
        register_date: [],
        shopname: "", //店铺名称
        black_status: "", //用户状态
        default_delivery_id: "",
        page: 1,
        pageSize: 10,
      },
      from1: {
        sale_id: "",
        mobile: "",
        fullname: "", //会员名称
        min_register_date: "", //最小注册时间
        max_register_date: "", //最大注册时间
        min_register_day: "", //最小注册天数
        max_register_day: "", //最大注册天数
        industry: "", //行业id
        min_weight: "", //最小重量
        max_weight: "", //最大重量
        min_order_number: "", //最小订单数
        max_order_number: "", //最大订单数
        is_vip: "", //是否会员 0否 1是
        member_label_ids: [], //会员标签列表
        member_grade: "", // 用户等级 单选
        purchase_hierarchy: [], //购买能力 多选
        customer_activity: "", //客户活跃度 单选
        customer_status: [], //下单状态 多选
        lossing_customer_reason: "", //原因 单选
        default_delivery_id: "",
        shopname: "", //店铺名称
        black_status: "", //用户状态
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      currentPage: 1,
      total: 0,
      storelist: [],
      salelist: [],
      multipleSelection: [],

      Filtersearchlist: [
        {
          type: "input",
          name: "客户电话",
          clearable: true,
          model: "mobile",
          placeholder: "请输入客户电话",
        },
        {
          type: "input",
          name: "客户姓名",
          clearable: true,
          model: "fullname",
          placeholder: "请输入客户姓名",
        },
        {
          type: "input",
          name: "店铺名称",
          clearable: true,
          model: "shopname",
          placeholder: "请输入店铺名称",
        },
        {
          type: "select",
          name: "从事行业",
          clearable: true,
          model: "industry",
          placeholder: "请选择从事行业",
          label: "label",
          value: "value",
          selectoption: PROFESSION_MAP,
        },
        {
          type: "select",
          name: "所属销售",
          clearable: true,
          filterable: true,
          model: "sale_id",
          placeholder: "请选择所属销售",
          selectoptionname: "sale_id_list",
          label: "fullname",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户状态",
          clearable: true,
          model: "black_status",
          placeholder: "请选择客户状态",

          label: "label",
          value: "value",
          selectoption: Object.values(DISABLED_STATUS),
        },
        {
          type: "select",
          name: "客户等级",
          clearable: true,
          model: "member_grade",
          placeholder: "请选择客户等级",
          selectoptionname: "customer_grade",
          label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户标签",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "member_label_ids",
          placeholder: "请选择客户标签",
          selectoptionname: "member_label_list",
          label: "name",
          value: "id",
          selectoption: [],
        },
        {
          type: "select",
          name: "是否会员",
          clearable: true,
          model: "is_vip",
          placeholder: "请选择是否会员",
          label: "label",
          value: "value",
          selectoption: Object.values(MEMBER_VIP_STATUS),
        },
        {
          type: "numinput",
          name: "注册天数",
          clearable: true,
          minmodel: "min_register_day",
          maxmodel: "max_register_day",
          placeholdermin: "请输入",
          placeholdermax: "请输入",
        },
        {
          type: "daterange",
          name: "注册日期",
          clearable: true,
          model: "register_date",
          startmodel: "min_register_date",
          endmodel: "max_register_date",
          startplaceholder: "注册日期起",
          endplaceholder: "注册日期止",
        },
        // {
        //   type: "numinput",
        //   name: "下单总重",
        //   clearable: true,
        //    digit:2,
        //   minmodel: "min_weight",
        //   maxmodel: "max_weight",
        //   placeholdermin: "请输入",
        //   placeholdermax: "请输入",
        // },
        {
          type: "numinput",
          name: "下单件数",
          clearable: true,
          minmodel: "min_order_number",
          maxmodel: "max_order_number",
          placeholdermin: "请输入",
          placeholdermax: "请输入",
        },
        {
          type: "select",
          name: "客户购买能力",
          clearable: true,
          filterable: true,
          multiple: true,
          model: "purchase_hierarchy",
          placeholder: "请选择客户购买能力",
          selectoptionname: "purchase_hierarchy",
          label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户活跃度",
          clearable: true,
          model: "customer_activity",
          placeholder: "请选择客户活跃度",
          selectoptionname: "customer_activity",
          label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "客户下单状态",
          filterable: true,
          clearable: true,
          multiple: true,
          model: "customer_status",
          placeholder: "请选择客户下单状态",
          selectoptionname: "customer_status",
          label: "value",
          value: "key",
          selectoption: [],
        },

        {
          type: "select",
          name: "客户流失原因",
          clearable: true,
          model: "lossing_customer_reason",
          placeholder: "请选择客户流失原因",
          selectoptionname: "lossing_customer_reason",
          label: "value",
          value: "key",
          selectoption: [],
        },
        {
          type: "select",
          name: "默认自提点",
          clearable: true,
          model: "default_delivery_id",
          placeholder: "请选择用户默认自提点",
          selectoptionname: "default_delivery_id",
          label: "name",
          value: "id",
          selectoption: [],
        },
      ],
    };
  },
  created() {
    if (window.location.href.indexOf("?") > -1) {
      /** 历史丢参问题，修复 start */
      const url = this.tool.getUrl(window.location.href);
      // 无效的值
      const invalid = ["", null, undefined, "null", "undefined"];
      url.page = (invalid.includes(url.page) && 1) || url.page;
      url.pageSize = (invalid.includes(url.pageSize) && 10) || url.pageSize;
      /** 历史丢参问题，修复 end */
      this.from = url;
      this.from1 = url;
      this.currentPage = Number(this.from1.page);
      this.from1.pageSize = Number(this.from1.pageSize);
      console.log(this.from1);
    }
    this.hqlist();
    this.getsaleselectlist();
    this.ajaxGetmemberconditionlist();
    this.getmemberlabelall();
    this.getdeliverylistall();
  },
  methods: {
    onEditRemark(e) {
      this.$refs.remarkDialogRef.addData(e);
    },
    getdeliverylistall() {
      this.$api.tdc.deliverylistall().then((res) => {
        console.log(res);
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "default_delivery_id"
          ) {
            el.selectoption = [...res.data];
          }
        });
      });
    },
    getmemberlabelall() {
      this.$api.tdc.memberlabelall().then((res) => {
        console.log(res);
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "member_label_list"
          ) {
            el.selectoption = [...res.data];
          }
        });
      });
    },
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      /** 新导出逻辑 */
      this.disabledExport = true;
      const { username } = JSON.parse(sessionStorage.getItem("userInfo"));
      try {
        // 组合需要的参数
        const query = {
          ...this.from1,
          token: sessionStorage.getItem("token"),
          user_name: username,
        };
        await posttdcMemberListExport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax posttdcMemberListExport err", err);
        this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 客户详情
     */
    CustomerDetailschange(row) {
      const memberId = row.id;

      this.$refs.CustomerDetailsDialogref.onInitData(memberId);
    },
    ajaxGetmemberconditionlist() {
      this.$api.tdc.memberconditionlist().then((res) => {
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            res.data[el.selectoptionname]
          ) {
            // console.log(el.selectoptionname,res.data[el.selectoptionname])
            if (el.multiple) {
              el.selectoption = [...res.data[el.selectoptionname]];
            } else {
              el.selectoption = [
                { value: "全部", key: "" },
                ...res.data[el.selectoptionname],
              ];
            }
          }
        });
      });
    },
    labelstitle(e) {
      return e.map((item) => item.name).join(",");
    },
    getList(e) {
      this.hqlist();
    },
    binding() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择会员");
      } else {
        this.$refs.bindingsales.hqinfo(this.multipleSelection, this.salelist);
      }
    },
    handleSelectionChange(val) {
      console.log(val, "选中的数据");
      //   this.$emit("tablevalue", val);
      this.multipleSelection = val;
    },
    getsaleselectlist() {
      this.$api.SalesP.saleselectlist().then((res) => {
        this.salelist = res.data;
        this.Filtersearchlist.forEach((el) => {
          if (
            el.type == "select" &&
            el.selectoptionname &&
            el.selectoptionname == "sale_id_list"
          ) {
            el.selectoption = [{ id: "", fullname: "全部" }, ...this.salelist];
          }
        });
      });
    },
    search(e) {
      this.from1 = e;
      this.from.page = 1;
      this.from1.page = 1;
      this.currentPage = 1;
      this.from = this.tool.DeepCopy({}, this.from1);
      this.hqlist();
      this.tool.getResult(this.from, window.location.href);
    },
    Refresh() {
      this.from = {
        sale_id: "",
        mobile: "",
        fullname: "", //会员名称
        min_register_date: "", //最小注册时间
        max_register_date: "", //最大注册时间
        min_register_day: "", //最小注册天数
        max_register_day: "", //最大注册天数
        industry: "", //行业id
        min_weight: "", //最小重量
        max_weight: "", //最大重量
        min_order_number: "", //最小订单数
        max_order_number: "", //最大订单数
        is_vip: "", //是否会员 0否 1是
        member_label_ids: [], //会员标签列表
        member_grade: "", // 用户等级 单选
        purchase_hierarchy: [], //购买能力 多选
        customer_activity: "", //客户活跃度 单选
        customer_status: [], //下单状态 多选
        lossing_customer_reason: "", //原因 单选
        default_delivery_id: "",
        shopname: "", //店铺名称
        black_status: "", //用户状态
        page: 1,
        pageSize: 10,
      };
      this.from1 = {
        sale_id: "",
        mobile: "",
        fullname: "", //会员名称
        min_register_date: "", //最小注册时间
        max_register_date: "", //最大注册时间
        min_register_day: "", //最小注册天数
        max_register_day: "", //最大注册天数
        industry: "", //行业id
        min_weight: "", //最小重量
        max_weight: "", //最大重量
        min_order_number: "", //最小订单数
        max_order_number: "", //最大订单数
        is_vip: "", //是否会员 0否 1是
        member_label_ids: [], //会员标签列表
        member_grade: "", // 用户等级 单选
        purchase_hierarchy: [], //购买能力 多选
        customer_activity: "", //客户活跃度 单选
        customer_status: [], //下单状态 多选
        lossing_customer_reason: "", //原因 单选
        default_delivery_id: "",
        shopname: "", //店铺名称
        black_status: "", //用户状态
        page: 1,
        pageSize: 10,
      };
      this.currentPage = 1;
      this.tool.getResult(this.from1, window.location.href);
      this.hqlist();
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.tool.getResult(this.from1, window.location.href);
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.tool.getResult(this.from1, window.location.href);
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.tdc.memberList(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.liquidate_amount_total = res.data.liquidate_amount_total;
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss">
.freight-container.orderlist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .bjsearch {
    background: #333333;
    border-color: #333333;
    margin-right: 5px;
  }

  .bjsearch:active {
    background: #333333;
    border-color: #333333;
  }

  .checked-box {
    padding: 13px 15px;
  }

  .title {
    background: #ffffff;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    .title-style {
      color: #999999;
      span {
        color: #13ae67;
        font-size: 20px;
      }
    }
    .seach {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;

      .inputs {
        // width: 207px;
        margin-right: 8px;
      }

      .multiple-select {
        width: 250px;
      }
    }
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .colors {
    color: #fa884c;
  }

  .times {
    margin-right: 8px;
  }

  // .el-picker-panel {
  //   left: 1245px !important;
  // }
}
</style>
